import { Action } from '@/_core/fluxstore/types';
import { NotificationsState } from '../types';
import { useNotificationsStore } from '../useModule';

const { registerReducer } = useNotificationsStore();

export class ShowAllNotifications extends Action<NotificationsState> {
    public static ACTION_TYPE = 'ShowAllNotifications';
    public constructor() {
        super(ShowAllNotifications.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer = (state: NotificationsState, action: ShowAllNotifications): void => {
    state.isDismissedNotificationsVisible = true;
};

//@ts-ignore
registerReducer(ShowAllNotifications.ACTION_TYPE, reducer);
